// Menções em comentários + notificações no app.
import { supabase } from './supabase';

export interface Person {
  id: string;
  name: string;
}

export interface Notification {
  id: string;
  productId: string | null;
  text: string;
  fromName: string | null;
  read: boolean;
  at: string;
}

/** Pessoas da organização (para marcar em comentários). Duas consultas: não há
 *  FK memberships→profiles para o PostgREST "embutir", então juntamos no JS. */
export async function loadPeople(orgId: string): Promise<Person[]> {
  const { data: mems } = await supabase
    .from('memberships')
    .select('user_id')
    .eq('org_id', orgId);
  const ids = ((mems ?? []) as { user_id: string }[]).map((m) => m.user_id);
  if (!ids.length) return [];
  const { data: profs } = await supabase
    .from('profiles')
    .select('id, full_name, email')
    .in('id', ids);
  const byId = new Map(
    ((profs ?? []) as { id: string; full_name: string | null; email: string | null }[]).map((p) => [
      p.id,
      p,
    ]),
  );
  return ids
    .map((id) => {
      const p = byId.get(id);
      return { id, name: p?.full_name || p?.email || '—' };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
}

export async function loadNotifications(userId: string): Promise<Notification[]> {
  const { data } = await supabase
    .from('notifications')
    .select('id, product_id, text, from_name, read, at')
    .eq('user_id', userId)
    .order('at', { ascending: false })
    .limit(40);
  return ((data ?? []) as Record<string, unknown>[]).map((r) => ({
    id: r.id as string,
    productId: (r.product_id as string) ?? null,
    text: r.text as string,
    fromName: (r.from_name as string) ?? null,
    read: Boolean(r.read),
    at: r.at as string,
  }));
}

export async function markRead(id: string): Promise<void> {
  await supabase.from('notifications').update({ read: true }).eq('id', id);
}

export async function markAllRead(userId: string): Promise<void> {
  await supabase.from('notifications').update({ read: true }).eq('user_id', userId).eq('read', false);
}

/** Cria notificações para os destinatários (menções). */
export async function createNotifications(
  rows: {
    orgId: string;
    userId: string;
    productId: string | null;
    noteId: string | null;
    fromName: string | null;
    text: string;
  }[],
): Promise<void> {
  if (!rows.length) return;
  await supabase.from('notifications').insert(
    rows.map((r) => ({
      org_id: r.orgId,
      user_id: r.userId,
      product_id: r.productId,
      note_id: r.noteId,
      from_name: r.fromName,
      text: r.text,
    })),
  );
}
